export default __webpack_public_path__ + "static/media/cucumber.6c4ad7dd.png";